export const corePrinciples = [
    {
        number: '01',
        title: 'Subtraction first',
        body: 'Every formulation meeting starts with what we can remove. An ingredient stays only if taking it out makes the result measurably worse. Most do not survive that question.'
    },
    {
        number: '02',
        title: 'Evidence, then opinion',
        body: 'We use actives with decades of published data behind them, at doses those studies actually used. If the only evidence is a supplier’s brochure, it does not go in the jar.'
    },
    {
        number: '03',
        title: 'Built to be finished',
        body: 'A product you abandon half-used has failed, however good the formula was. One step, one texture, refillable, and priced so reordering is not a decision.'
    }
]

export const founders = [
    {
        role: 'Co-founder',
        name: 'Dr. Camille Roux',
        image: '/images/team-monica.png',
        alt: 'Portrait of Dr. Camille Roux',
        bio: 'Camille spent eleven years in clinical dermatology in Lyon, where most of her week was spent unpicking damage done by well-intentioned routines. She leads formulation and decides what does not go in.'
    },
    {
        role: 'Co-founder',
        name: 'Dr. Ingrid Lindqvist',
        image: '/images/team-elena.png',
        alt: 'Portrait of Dr. Ingrid Lindqvist',
        bio: 'Ingrid researched barrier lipids and transepidermal water loss for nine years before moving into industry. She runs our trials and holds the line on what we are allowed to claim.'
    }
]

export const commitments = [
    {
        number: '01',
        title: 'To your skin',
        image: '/images/pledge-skin.png',
        alt: 'Close detail of clear, freckled skin in natural light',
        body: 'No fragrance, no essential oils, no colourant, and never any animal testing at any stage. The formula supports what your skin already does rather than creating something it has to keep buying.'
    },
    {
        number: '02',
        title: 'To the planet',
        image: '/images/pledge-planet.png',
        alt: 'A glass sphere held up to a mountain lake at sunrise',
        body: 'The glass vessel is permanent and the inner pod is the only thing you reorder, which removes 94% of packaging weight per refill. No outer carton, no leaflet, no tissue paper.'
    },
    {
        number: '03',
        title: 'To plain speech',
        image: '/images/pledge-transparency.png',
        alt: 'Each ingredient measured out in its own glass dish under daylight',
        body: 'Full formula and percentages are printed on the jar and on this site. Every figure we publish comes from a trial we ran, and we say how many people were in it.'
    }
]
